export const SALE_FLOW_STAGE = {
  signature: "signature",
  networkSwitch: "network_switch",
  approval: "approval",
  approvalReceipt: "approval_receipt",
  purchase: "purchase",
  purchaseReceipt: "purchase_receipt",
} as const;

export const SALE_CHAIN_DECIMALS = {
  bscMainnet: 18,
  defaultStablecoin: 6,
} as const;

export const SALE_SUPPORTED_CHAIN_ERROR =
  "Please switch to one of the supported sale networks before buying.";

export const SALE_PENDING_ERROR =
  "A wallet action is already in progress. Please finish it in your wallet.";

export const SALE_RECEIPT_ERROR =
  "Transaction not found on the selected network. Please verify the chain and try again.";

export const SALE_FLOW_TIMEOUT_ERROR =
  "The transaction is taking longer than expected. Please check your wallet and try again.";

// Backstop that releases a stuck sale-flow lock if a stage (wallet popup or
// receipt wait) never settles, e.g. on a hung WalletConnect relay / RPC.
// Re-armed on every stage transition, so a progressing flow is never killed.
export const SALE_FLOW_TIMEOUT_MS = 300_000;

export const BSC_CHAIN_ID = 56;
